import { selectTab } from "@/state/functions";
import { RootState } from "@/state/reducer";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SignWritingField from "./tests/signWriting";

const TestStepOne  = () => {
   const State = useSelector((state: RootState) => state);
   const dispatch = useDispatch();

   const onFinish = selectTab.bind(this, "step2")
   
    return(
    <div className="page greeting gridCenter w100">
       <div className="inner columnCenter gap24">
          <h1>Шаг1: Изобразите на экране свой автограф, не отрывая мышку и не выходя за пределы поля</h1>
          <SignWritingField onFinish={onFinish} />
          <div className="btn mainBtn" onClick={selectTab.bind(this, "step2")}>
             Перейти на этап 2
          </div>
          <div className="btn mainBtn" onClick={selectTab.bind(this, "")}>
             Начать заново
          </div>
       </div>
    </div>)
}

export default TestStepOne;